export const FIELD_TYPE_STRING = 'string'
export const FIELD_TYPE_BOOLEAN = 'boolean'
export const FIELD_TYPE_NUMBER = 'number'
export const FIELD_TYPE_DATE = 'date'
export const FIELD_TYPE_MIXED = 'mixed'
export const FIELD_TYPE_UUID = 'uuid'
export const FIELD_TYPE_IMAGE = 'image'
export const FIELD_TYPE_VIDEO = 'video'
export const FIELD_TYPE_MEDIA = 'media'
export const FIELD_TYPE_AUDIO = 'audio'
export const FIELD_TYPE_LINK = 'link'
export const FIELD_TYPE_ARRAY = 'array'
export const FIELD_TYPE_STRING_OR_ARRAY = 'string_or_array'
export const FIELD_TYPE_NUMBER_OR_ARRAY = 'number_or_array'
export const FIELD_TYPE_FILENAME = 'filename'
export const FIELD_TYPE_UNDEFINED = 'undefined'
export const FIELD_TYPE_NULL = 'null'
export const FIELD_TYPE_LOCATION = 'location'
export const FIELD_TYPE_SPACE_DELIMITED = 'space_delimited'

export const FILTER_TYPE_DISCRETE = 'DISCRETE'
export const FILTER_TYPE_RANGE = 'RANGE'
export const FILTER_TYPE_DATE = 'DATE'
export const FILTER_TYPE_TEXT = 'TEXT'

export const FORMATS_UTM = 'FORMATS_UTM'
export const FORMATS_DEC_DEG = 'FORMATS_DEC_DEG'
export const FORMATS_DEG_MIN_SEC = 'FORMATS_DEG_MIN_SEC'

export const UPDATE_FIELD_ORDER = 'UPDATE_FIELD_ORDER'
export const EDIT_FEATURE = 'EDIT_FEATURE'
export const DELETE_FEATURE = 'DELETE_FEATURE'

export const UNDEFINED_KEY = '@@MAPFILTER/UNDEFINED'
